import React from 'react';
import BrandPage from './BrandPage';

const EconovaPage = () => <BrandPage brandSlug="econova" />;

export default EconovaPage;
